import styled from 'styled-components'

export const OnlineIcon = styled.div`
    width: 57px;
    height: 19px;
    background-image: url('/assets/img/online.svg');
    background-size: 100%;
    background-position: center;
`
